import React from 'react';
import Timeline from './Timeline';
import ProgramsTableSection from './ProgramsTableSection/ProgramsTablesSection';

function Programs() {
  return (
    <>
      <Timeline></Timeline>
      <ProgramsTableSection></ProgramsTableSection>
    </>
  );
}

export default Programs;
